/* בול פרקט: דף קטגוריה (שיחה 07). העתק של ה-JS מסניפט 19, מותאם לשופיפיי */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return [].slice.call((r || document).querySelectorAll(s)); };
  function go(u) { u.searchParams.delete('page'); nav(u.toString(), true); }

  /* ---------- סינון בלי טעינת עמוד (כמו קוד 72318 באתר הישן) ----------
     מושכים רק את ה-section, מחליפים את התוכן ומעדכנים את הכתובת. כל תקלה: טעינה רגילה. */
  function nav(href, push) {
    var root = $('.bpnc-page[data-section]');
    if (!root || !window.fetch || !window.history || !history.pushState || !window.DOMParser) { window.location.href = href; return; }
    var u = new URL(href, window.location.href);
    var f = new URL(u.toString()); f.searchParams.set('section_id', root.getAttribute('data-section'));
    if (!document.getElementById('bpncLoadCss')) {
      var css = document.createElement('style'); css.id = 'bpncLoadCss';
      css.textContent = '.bpnc-page.bpnc-loading .bpnc-grid,.bpnc-page.bpnc-loading .bpnc-side{opacity:.45;pointer-events:none;transition:opacity .15s}';
      document.head.appendChild(css);
    }
    root.classList.add('bpnc-loading'); root.setAttribute('aria-busy', 'true');
    fetch(f.toString(), { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nr = $('.bpnc-page', doc);
        if (!nr) throw new Error('no page');
        var msOn = !!$('.bpnc-msheet.on', root);
        var pn = $('.bpnc-msheet .pn', root), pnTop = pn ? pn.scrollTop : 0;
        var closed = $$('.bpnc-g.closed > h3', root).map(function (h) { return h.textContent.trim(); });
        var nn = document.importNode(nr, true);
        root.replaceWith(nn);
        $$('.bpnc-g > h3', nn).forEach(function (h) { if (closed.indexOf(h.textContent.trim()) > -1) h.parentElement.classList.add('closed'); });
        if (msOn) { var m = $('.bpnc-msheet', nn); if (m) { m.classList.add('on'); var p2 = $('.pn', m); if (p2) p2.scrollTop = pnTop; } }
        if (push) history.pushState({ bpnc: 1 }, '', u.toString());
        boot();
        document.dispatchEvent(new CustomEvent('bpnc:updated', { detail: { url: u.toString() } }));
        /* הודעה לקורא מסך: כמה דגמים נמצאו */
        var live = document.getElementById('bpncLive');
        if (!live) { live = document.createElement('div'); live.id = 'bpncLive'; live.setAttribute('aria-live', 'polite'); live.style.cssText = 'position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0)'; document.body.appendChild(live); }
        var cn = $('.bpnc-count', nn); live.textContent = cn ? cn.textContent.replace(/\s+/g, ' ').trim() : 'התוצאות עודכנו';
      })
      .catch(function () { window.location.href = u.toString(); });
  }
  if (window.history && history.replaceState) {
    try { if (!history.state || !history.state.bpnc) history.replaceState({ bpnc: 1 }, ''); } catch (e) {}
    window.addEventListener('popstate', function (e) { if (e.state && e.state.bpnc && $('.bpnc-page[data-section]')) nav(window.location.href, false); });
  }

  function init(root) {
    var sectionId = root.getAttribute('data-section');

    /* ---------- גובה ההדר הדביק, כדי שהסרגל יידבק מתחתיו ---------- */
    function topOffset() {
      var best = 0, vw = window.innerWidth;
      $$('header, .header-section, #header-group, [class*="header"]').forEach(function (e) {
        if (root.contains(e)) return;
        var cs = getComputedStyle(e);
        if (cs.position !== 'sticky' && cs.position !== 'fixed') return;
        var r = e.getBoundingClientRect();
        if (r.width < vw * 0.85 || r.height < 24 || r.height > 260 || r.top > 70 || r.bottom < 10) return;
        if (r.bottom > best) best = r.bottom;
      });
      root.style.setProperty('--bpnc-top', Math.round(best) + 'px');
    }
    topOffset(); window.addEventListener('resize', topOffset); setTimeout(topOffset, 1200);
    var lastT = 0;
    window.addEventListener('scroll', function () { var n = Date.now(); if (n - lastT > 400) { lastT = n; topOffset(); } }, { passive: true });

    /* ---------- סינונים: קיפול, "הצגת הכל", מחיר, מיון ---------- */
    root.addEventListener('click', function (e) {
      var h = e.target.closest('.bpnc-g>h3');
      if (h) { h.parentElement.classList.toggle('closed'); return; }
      var m = e.target.closest('.bpnc-more');
      if (m) { $$('.bpnc-x', m.closest('.bpnc-g')).forEach(function (x) { x.classList.remove('bpnc-hidden'); }); m.remove(); return; }
      var q = e.target.closest('.bpnc-qrow a[data-param]');
      if (q) {
        e.preventDefault();
        var u = new URL(window.location.href), p = q.getAttribute('data-param');
        u.searchParams.delete(p);
        if (q.getAttribute('data-on') !== 'true') {
          q.getAttribute('data-values').split('|').forEach(function (v) { if (v) u.searchParams.append(p, v); });
        }
        go(u); return;
      }
      /* קישורי סינון, ניקוי ודפדוף באותה קטגוריה: בלי טעינה */
      var a = e.target.closest('a[href]');
      if (a && !e.defaultPrevented && !e.metaKey && !e.ctrlKey && !e.shiftKey && e.button === 0 && !a.target
          && !a.hasAttribute('data-add') && !a.closest('.bpnc-loadmore') && !a.hasAttribute('download')) {
        var au = new URL(a.href, window.location.href);
        if (au.origin === window.location.origin && au.pathname === window.location.pathname && au.search !== window.location.search) {
          e.preventDefault(); nav(au.toString(), true); return;
        }
      }
    });
    $$('.bpnc-pricef', root).forEach(function (g) {
      var mn = $('.bpnc-rmin', g), mx = $('.bpnc-rmax', g), l1 = $('.bpnc-pmin', g), l2 = $('.bpnc-pmax', g);
      function vals() { var a = Math.min(+mn.value, +mx.value), b = Math.max(+mn.value, +mx.value); return [a, b]; }
      function sync() { var v = vals(); l1.textContent = '₪' + v[0]; l2.textContent = '₪' + v[1]; }
      mn.addEventListener('input', sync); mx.addEventListener('input', sync);
      $('.bpnc-pgo', g).addEventListener('click', function () {
        var v = vals(), u = new URL(window.location.href);
        if (v[0] > 0) u.searchParams.set(g.getAttribute('data-pmin'), v[0]); else u.searchParams.delete(g.getAttribute('data-pmin'));
        if (v[1] < +mx.max) u.searchParams.set(g.getAttribute('data-pmax'), v[1]); else u.searchParams.delete(g.getAttribute('data-pmax'));
        go(u);
      });
    });
    var sort = $('.bpnc-sort', root);
    if (sort) sort.addEventListener('change', function () { var u = new URL(window.location.href); u.searchParams.set('sort_by', sort.value); go(u); });

    /* ---------- "הצג עוד מוצרים": מושך את העמוד הבא של ה-section בלבד ---------- */
    root.addEventListener('click', function (e) {
      var a = e.target.closest('.bpnc-loadmore a');
      if (!a) return;
      e.preventDefault();
      if (a.getAttribute('aria-busy') === 'true') return;
      a.setAttribute('aria-busy', 'true'); var txt = a.textContent; a.textContent = 'טוען מוצרים...';
      var u = new URL(a.getAttribute('data-next'), window.location.origin);
      u.searchParams.set('section_id', sectionId);
      fetch(u.toString(), { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var grid = $('.bpnc-grid', root), items = $$('.bpnc-grid > li', doc);
          if (!items.length) throw new Error('empty');
          items.forEach(function (li) { grid.appendChild(document.importNode(li, true)); });
          var nx = $('.bpnc-loadmore a', doc);
          if (nx) { a.setAttribute('data-next', nx.getAttribute('data-next')); a.href = nx.getAttribute('href'); a.textContent = txt; a.removeAttribute('aria-busy'); }
          else { a.parentNode.remove(); }
          var sh = $('.bpnc-shown', root); if (sh) sh.textContent = $$('.bpnc-grid > li', root).length;
          renderCmp();
        })
        .catch(function () { a.textContent = 'נסו שוב'; a.removeAttribute('aria-busy'); });
    });

    /* ---------- הוספה לסל ישירות מהכרטיס ---------- */
    var toast = $('.bpnc-toast', root), tt;
    function say(msg) { if (!toast) return; $('.t', toast).textContent = msg; toast.classList.add('on'); clearTimeout(tt); tt = setTimeout(function () { toast.classList.remove('on'); }, 3500); }
    root.addEventListener('click', function (e) {
      var a = e.target.closest('a[data-add]');
      if (!a) return;
      e.preventDefault();
      if (a.getAttribute('aria-busy') === 'true') return;
      a.setAttribute('aria-busy', 'true');
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: +a.getAttribute('data-add'), quantity: 1 }] })
      })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return fetch('/cart.js'); })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          a.removeAttribute('aria-busy');
          say('המוצר נוסף לסל');
          document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'bp-collection', data: { itemCount: cart.item_count, source: 'bp-collection' } } }));
        })
        .catch(function () { window.location.href = a.href; });
    });

    /* ---------- השוואת דגמים (עד 3, נשמר בין דפים) ---------- */
    var KEY = 'bpCmp';
    function load() { try { return JSON.parse(sessionStorage.getItem(KEY)) || []; } catch (e) { return []; } }
    function save(l) { try { sessionStorage.setItem(KEY, JSON.stringify(l)); } catch (e) {} }
    function fromBtn(b) {
      var li = b.closest('.bpnc-card');
      return {
        id: b.getAttribute('data-id'), name: b.getAttribute('data-name'), img: b.getAttribute('data-img'),
        price: b.getAttribute('data-price'), url: b.getAttribute('data-url'),
        specs: $$('.bpnc-spec', li).map(function (s) { return [s.getAttribute('data-k') || '', s.textContent.trim()]; }),
        stock: $('.bpnc-stock', li) ? 'אזל מהמלאי' : 'זמין להזמנה'
      };
    }
    function renderCmp() {
      var l = load(), ids = l.map(function (x) { return x.id; });
      $$('.bpnc-cmpopen .bpnc-cn', root).forEach(function (e) { e.textContent = l.length; });
      var bar = $('.bpnc-cmpbar', root); if (bar) bar.classList.toggle('on', l.length > 0);
      var box = $('.bpnc-cmpitems', root);
      if (box) {
        box.innerHTML = '';
        l.forEach(function (p) {
          var d = document.createElement('div'); d.className = 'bpnc-ci';
          d.innerHTML = (p.img ? '<img alt="">' : '') + '<span></span><button type="button" style="color:#9DB3A5;font-size:15px" aria-label="הסרה">✕</button>';
          if (p.img) $('img', d).src = p.img;
          $('span', d).textContent = p.name;
          $('button', d).addEventListener('click', function () { toggle(p.id); });
          box.appendChild(d);
        });
      }
      $$('.bpnc-cmp', root).forEach(function (b) { b.setAttribute('aria-pressed', ids.indexOf(b.getAttribute('data-id')) > -1 ? 'true' : 'false'); });
    }
    function toggle(id, btn) {
      var l = load(), i = -1;
      l.forEach(function (x, k) { if (x.id === id) i = k; });
      if (i > -1) l.splice(i, 1);
      else { if (l.length >= 3) { alert('אפשר להשוות עד 3 דגמים'); return; } if (btn) l.push(fromBtn(btn)); }
      save(l); renderCmp();
    }
    root.addEventListener('click', function (e) {
      var b = e.target.closest('.bpnc-cmp'); if (!b) return;
      e.preventDefault(); toggle(b.getAttribute('data-id'), b);
    });
    function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }
    function openCmp() {
      var l = load(); if (!l.length) { alert('בוחרים דגמים להשוואה בעזרת הכפתור ⇄ בכרטיס'); return; }
      var keys = [];
      l.forEach(function (p) { p.specs.forEach(function (s) { var k = s[0] || 'מאפיין'; if (keys.indexOf(k) < 0) keys.push(k); }); });
      var rows = [['תמונה', function (p) { return p.img ? '<img src="' + esc(p.img) + '" alt="">' : ''; }],
        ['דגם', function (p) { return '<a href="' + esc(p.url) + '">' + esc(p.name) + '</a>'; }],
        ['מחיר', function (p) { return '<b style="color:#0D3D28;font-size:18px">' + esc(p.price) + '</b>'; }]];
      keys.forEach(function (k) { rows.push([k, function (p) { var v = '—'; p.specs.forEach(function (s) { if ((s[0] || 'מאפיין') === k) v = s[1]; }); return esc(v); }]); });
      rows.push(['זמינות', function (p) { return esc(p.stock); }]);
      var html = '<table class="bpnc-cmptbl">' + rows.map(function (r) {
        var vals = l.map(r[1]);
        var diff = r[0] !== 'תמונה' && r[0] !== 'דגם' && vals.some(function (v) { return v !== vals[0]; });
        return '<tr><th>' + esc(r[0]) + '</th>' + vals.map(function (v) { return '<td class="' + (diff ? 'df' : '') + '">' + v + '</td>'; }).join('') + '</tr>';
      }).join('') + '</table><p style="font-size:13px;color:#8A938D;margin-top:12px">הצהוב מסמן את מה ששונה בין הדגמים.</p>';
      $('.bpnc-cmptable', root).innerHTML = html;
      $('.bpnc-cmpsheet', root).classList.add('on');
    }
    $$('.bpnc-cmpopen, .bpnc-cmpgo', root).forEach(function (b) { b.addEventListener('click', openCmp); });
    var clr = $('.bpnc-cmpclr', root); if (clr) clr.addEventListener('click', function () { save([]); renderCmp(); });
    renderCmp();

    /* ---------- חלוניות, מובייל ---------- */
    var ms = $('.bpnc-msheet', root), cs = $('.bpnc-cmpsheet', root);
    $$('.bpnc-mfilter', root).forEach(function (b) { b.addEventListener('click', function () { if (ms) ms.classList.add('on'); }); });
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-bpnc-close]') || e.target === ms || e.target === cs) {
        if (ms) ms.classList.remove('on'); if (cs) cs.classList.remove('on');
      }
    });
    var mt = $('.bpnc-mtop', root); if (mt) mt.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });

    var quiz = $('.bpnc-quiz', root), mq = window.matchMedia('(max-width:860px)');
    if (quiz) {
      var qh = $('h2', quiz);
      qh.setAttribute('role', 'button'); qh.setAttribute('tabindex', '0'); qh.setAttribute('aria-expanded', 'false');
      quiz.addEventListener('click', function (e) {
        if (!mq.matches) return;
        if (!quiz.classList.contains('bpnc-qopen')) { quiz.classList.add('bpnc-qopen'); qh.setAttribute('aria-expanded', 'true'); return; }
        if (e.target.closest('h2')) { quiz.classList.remove('bpnc-qopen'); qh.setAttribute('aria-expanded', 'false'); }
      });
      qh.addEventListener('keydown', function (e) { if ((e.key === 'Enter' || e.key === ' ') && mq.matches) { e.preventDefault(); quiz.classList.toggle('bpnc-qopen'); } });
    }

    /* ---------- עמוד אינדקס: חיפוש, מיון וסינון לפי יצרן או סוג ---------- */
    var ixbar = $('.bpnc-ixbar', root);
    if (ixbar) {
      var ul = $('.bpnc-ixgrid', root), cards = $$('.bpnc-ixcard', root), many = ixbar.getAttribute('data-many');
      var counts = {};
      cards.forEach(function (li) { var b = li.getAttribute('data-b'); if (b) counts[b] = (counts[b] || 0) + 1; });
      var cnt = $('.bpnc-ixcount', ixbar);
      Object.keys(counts).sort(function (a, b) { return counts[b] - counts[a]; }).slice(0, 6).forEach(function (b) {
        var bt = document.createElement('button'); bt.type = 'button'; bt.className = 'bpnc-ixchip'; bt.setAttribute('data-f', b); bt.textContent = b;
        ixbar.insertBefore(bt, cnt);
      });
      var q = '', f = '';
      function apply() {
        var shown = 0;
        cards.forEach(function (li) {
          var ok = (!f || li.getAttribute('data-b') === f) && (!q || li.getAttribute('data-name').indexOf(q) > -1);
          li.classList.toggle('bpnc-hidden', !ok); if (ok) shown++;
        });
        cnt.textContent = 'מוצגות ' + shown + ' ' + many + ' מתוך ' + cards.length;
      }
      $('input', ixbar).addEventListener('input', function (e) { q = e.target.value.trim().toLowerCase(); apply(); });
      $('.bpnc-ixsort', ixbar).addEventListener('change', function (e) {
        var v = e.target.value, arr = cards.slice();
        var num = function (li, a) { return +li.getAttribute(a) || 0; };
        if (v === 'n') arr.sort(function (a, b) { return num(b, 'data-n') - num(a, 'data-n'); });
        else if (v === 'p') arr.sort(function (a, b) { return (num(a, 'data-p') || 1e9) - (num(b, 'data-p') || 1e9); });
        else if (v === 'a') arr.sort(function (a, b) { return a.getAttribute('data-name').localeCompare(b.getAttribute('data-name'), 'he'); });
        else arr.sort(function (a, b) { return num(a, 'data-i') - num(b, 'data-i'); });
        arr.forEach(function (li) { ul.appendChild(li); });
      });
      ixbar.addEventListener('click', function (e) {
        var b = e.target.closest('.bpnc-ixchip'); if (!b) return;
        f = b.getAttribute('data-f') || '';
        $$('.bpnc-ixchip', ixbar).forEach(function (x) { x.classList.toggle('on', x === b); });
        apply();
      });
      apply();
    }
  }

  function boot() { $$('.bpnc-page').forEach(function (r) { if (!r.__bpnc) { r.__bpnc = 1; init(r); } }); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
